import axios from 'axios';
import toast from 'react-hot-toast';
import { client } from '@/services/api/axios.ts';
import { useMutation } from '@tanstack/react-query';

type PlantControlPanelResponse = {
  body: unknown;
};

export const usePostTriggerPlantDataTransmission = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: unknown) => void;
  onError?: (error: Error) => void;
} = {}) => {
  return useMutation({
    mutationFn: async ({ plantId }: { plantId: string }) => {
      const apiCall = async (): Promise<unknown> => {
        const { data } = await client.post<PlantControlPanelResponse>(
          `/plants/${plantId}/control-panel`,
          {
            routine: 'realtime-telemetry',
            action: 'heartbeat',
          }
        );
        return data.body;
      };

      return await toast.promise(apiCall(), {
        loading: 'Setting up data collection...',
        success: 'Plant will now report data automatically!',
        error: (err) => {
          if (axios.isAxiosError(err)) {
            return err?.response?.data?.message || 'Automated reporting setup failed.';
          }

          if (err instanceof Error) {
            return err.message;
          }

          return 'Unable to reach plant.';
        },
      });
    },
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error: Error) => {
      onError?.(error);
    },
  });
};
